 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		5: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		5: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"adff0ed38e7fa8598300b82fa0add4371073ab7a","3":"f0973e71de4939708d2bb23784009067cbf93e19","4":"51ed035c179315797f552d36435c8b0e72c532e8","6":"33e6280e","8":"component---src-pages-404-js","9":"component---src-pages-about-js","10":"component---src-pages-administration-documentation-js","11":"component---src-pages-administration-index-js","12":"component---src-pages-administration-rate-js","13":"component---src-pages-bedside-checklist-js","14":"component---src-pages-compatibility-caveats-js","15":"component---src-pages-compatibility-component-choice-js","16":"component---src-pages-compatibility-index-js","17":"component---src-pages-compatibility-results-js","18":"component---src-pages-disclaimer-js","19":"component---src-pages-index-js","20":"component---src-pages-patient-consent-considerations-js","21":"component---src-pages-patient-consent-js","22":"component---src-pages-positive-patient-identification-js","23":"component---src-pages-privacy-policy-js","24":"component---src-pages-requirements-cmv-negative-components-elective-js","25":"component---src-pages-requirements-cmv-negative-components-granulocyte-transfusion-js","26":"component---src-pages-requirements-cmv-negative-components-index-js","27":"component---src-pages-requirements-cmv-negative-components-iut-neonates-js","28":"component---src-pages-requirements-index-js","29":"component---src-pages-requirements-irradiation-car-t-therapy-js","30":"component---src-pages-requirements-irradiation-exchange-transfusion-js","31":"component---src-pages-requirements-irradiation-granulocyte-administration-js","32":"component---src-pages-requirements-irradiation-hla-matched-components-js","33":"component---src-pages-requirements-irradiation-hodgkin-lymphoma-js","34":"component---src-pages-requirements-irradiation-hsc-donors-js","35":"component---src-pages-requirements-irradiation-hsc-recipients-js","36":"component---src-pages-requirements-irradiation-hsc-transplant-js","37":"component---src-pages-requirements-irradiation-immunosuppressant-therapies-js","38":"component---src-pages-requirements-irradiation-index-js","39":"component---src-pages-requirements-irradiation-intrauterine-transfusion-js","40":"component---src-pages-requirements-irradiation-lymphocyte-immunodeficiency-js","41":"component---src-pages-requirements-irradiation-transfusion-from-relative-js","42":"component---src-pages-requirements-monoclonal-therapies-index-js","43":"component---src-pages-requirements-washed-red-cells-index-js","44":"component---src-pages-taco-assessment-js","45":"component---src-pages-taco-index-js","46":"component---src-pages-taco-manage-risk-js","47":"component---src-pages-terms-js","48":"component---src-pages-transfusion-reaction-immediate-actions-js","49":"component---src-pages-transfusion-reaction-index-js","50":"component---src-pages-transfusion-reaction-next-steps-js","51":"component---src-pages-transfusion-reaction-other-symptoms-js","52":"de61cd13"}[chunkId]||chunkId) + "-" + {"0":"957de65c715ade510eca","1":"29147cbc04bbc833f6a0","2":"19977c62b01e8d047817","3":"47614abbfd4408adf1b4","4":"88fee7c2e3a281aaa5c7","6":"d8d0cc857d504d2afa3e","8":"0a4ae1e845f319ec7972","9":"26a3e724d8ee0df44274","10":"70f9f2fa5402d93138d2","11":"fc20830be6d7ab0c0a12","12":"83c83832f70c66eb25fa","13":"ac7a5c99aad6aaf97256","14":"b81fb2fc967a2df447f7","15":"3d1c17f1e1f25924a14c","16":"242a09b76d50f285ceae","17":"29206f59f95033fbdb7d","18":"099b9f1fb8aac823ad6b","19":"2126cb3330804f1c4736","20":"100b1ba83bc6345e4919","21":"c3a64dda36a2cc33c73a","22":"adc8cb55e71d17288514","23":"a1c08ce482d99129727c","24":"570f16a86f8f33396862","25":"398de7438c9c95000d38","26":"8fc0345d906013ccf8ef","27":"794331c1994fe04cfbcd","28":"4046ae177752b3ee0cca","29":"3d36a8d7acef2074fc41","30":"5f692c1fa4d1f9a688e7","31":"6b16387693c2f44b928b","32":"3eeda9c9ceba8feecb0a","33":"9f28ad3a072c6480c438","34":"ba2126e281c7e6882ad5","35":"823be3dc32953b71d4d9","36":"c3fd6d602284876efcea","37":"b94fb956d22d4be0602d","38":"625f4f19a4f00aedefe1","39":"fc586430865d6acf7f08","40":"d71cb94bf602aa9611e6","41":"a5a0c8a7bbd1ef7f9994","42":"13b725e7d05b4efc4e5b","43":"eb4c4236ab869911c71d","44":"080578597f7b5aad65a0","45":"4e05e66c069e35edccae","46":"daa429df12e25a868ae1","47":"265a79d6dc02a25b6a72","48":"a9d4cf0bdacc0a05505f","49":"fed985e462913adf6b3a","50":"698dfdbed665bb7dda26","51":"2698120d96f719c36ce7","52":"c39badfaeacab224a3e0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"adff0ed38e7fa8598300b82fa0add4371073ab7a","3":"f0973e71de4939708d2bb23784009067cbf93e19","4":"51ed035c179315797f552d36435c8b0e72c532e8","6":"33e6280e","8":"component---src-pages-404-js","9":"component---src-pages-about-js","10":"component---src-pages-administration-documentation-js","11":"component---src-pages-administration-index-js","12":"component---src-pages-administration-rate-js","13":"component---src-pages-bedside-checklist-js","14":"component---src-pages-compatibility-caveats-js","15":"component---src-pages-compatibility-component-choice-js","16":"component---src-pages-compatibility-index-js","17":"component---src-pages-compatibility-results-js","18":"component---src-pages-disclaimer-js","19":"component---src-pages-index-js","20":"component---src-pages-patient-consent-considerations-js","21":"component---src-pages-patient-consent-js","22":"component---src-pages-positive-patient-identification-js","23":"component---src-pages-privacy-policy-js","24":"component---src-pages-requirements-cmv-negative-components-elective-js","25":"component---src-pages-requirements-cmv-negative-components-granulocyte-transfusion-js","26":"component---src-pages-requirements-cmv-negative-components-index-js","27":"component---src-pages-requirements-cmv-negative-components-iut-neonates-js","28":"component---src-pages-requirements-index-js","29":"component---src-pages-requirements-irradiation-car-t-therapy-js","30":"component---src-pages-requirements-irradiation-exchange-transfusion-js","31":"component---src-pages-requirements-irradiation-granulocyte-administration-js","32":"component---src-pages-requirements-irradiation-hla-matched-components-js","33":"component---src-pages-requirements-irradiation-hodgkin-lymphoma-js","34":"component---src-pages-requirements-irradiation-hsc-donors-js","35":"component---src-pages-requirements-irradiation-hsc-recipients-js","36":"component---src-pages-requirements-irradiation-hsc-transplant-js","37":"component---src-pages-requirements-irradiation-immunosuppressant-therapies-js","38":"component---src-pages-requirements-irradiation-index-js","39":"component---src-pages-requirements-irradiation-intrauterine-transfusion-js","40":"component---src-pages-requirements-irradiation-lymphocyte-immunodeficiency-js","41":"component---src-pages-requirements-irradiation-transfusion-from-relative-js","42":"component---src-pages-requirements-monoclonal-therapies-index-js","43":"component---src-pages-requirements-washed-red-cells-index-js","44":"component---src-pages-taco-assessment-js","45":"component---src-pages-taco-index-js","46":"component---src-pages-taco-manage-risk-js","47":"component---src-pages-terms-js","48":"component---src-pages-transfusion-reaction-immediate-actions-js","49":"component---src-pages-transfusion-reaction-index-js","50":"component---src-pages-transfusion-reaction-next-steps-js","51":"component---src-pages-transfusion-reaction-other-symptoms-js","52":"de61cd13"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"85edb2052831a1865bf1","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
